import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { IDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { SelectFieldOrderBy } from "@generation/schema-core/src/client/model/options/selectFieldOrderByEnum";
import { GetAdresFieldSet } from "@klantondersteuning/shared";
import { ISimpleForm } from "@klantondersteuning/shared/src/form/interface/SimpleForm/ISimpleForm";
import { PredefinedFieldType } from "@klantondersteuning/shared/src/form/interface/SimpleForm/PredefinedFieldType";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import { translate } from "@opencak-klantondersteuning/shared";

const dependsOnHoeCommunicatie: IDependsOn[] = [
  {
    property: "stap_contactgegevens__contactgegevens.hoeCommunicatie",
    if: DependsOnIfEnum.IsEqualToValue,
    value: "email",
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    property: "stap_contactgegevens__contactgegevens.hoeCommunicatie",
    if: DependsOnIfEnum.IsNotGiven,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

export const GetSimpleAvgFormulier = (): ISimpleForm => {
  return {
    name: "avg-formulier",
    steps: [
      {
        name: translate("AvgFormulierStapInleiding"),
        isIntroduction: true
      },
      {
        name: translate("AvgFormulierStapMijnRecht"),
        Sections: [
          {
            name: "stap_recht_recht",
            fields: {
              recht: {
                validate: {
                  isRequired: { value: true }
                },
                type: "select",
                options: [
                  {
                    label: translate("AvgRechtInzien"),
                    value: "Recht om mijn gegevens in te zien"
                  },
                  {
                    label: translate("AvgRechtWijzigen"),
                    value: "Recht om mijn gegevens te wijzigen"
                  },
                  {
                    label: translate("AvgRechtVerwijderen"),
                    value: "Recht om mijn gegevens te laten verwijderen"
                  },
                  {
                    label: translate("AvgRechtBeperken"),
                    value: "Recht om verwerken van mijn gegevens te beperken"
                  }
                ],
                ui: {
                  flexDirection: "column"
                }
              },
              regeling: {
                predefinedFieldType: PredefinedFieldType.regeling,
                isRequired: true,
                regelingOptions: [
                  RegelingOptions.BeschermdWonen,
                  RegelingOptions.MedicijnenMeeOpReis,
                  RegelingOptions.Gemoedsbezwaarden,
                  RegelingOptions.Onverzekerden,
                  RegelingOptions.BetalingsachterstandZorgpremie,
                  RegelingOptions.Wlz,
                  RegelingOptions.WmoAT,
                  RegelingOptions.Buitenland,
                  RegelingOptions.CBHC,
                  RegelingOptions.Onbekend
                ],
                orderOptionsBy: {
                  orderBy: SelectFieldOrderBy.Alphabetical,
                  exclusions: [RegelingOptions.Onbekend]
                }
              },
              toelichting: {
                predefinedFieldType: PredefinedFieldType.textArea
              }
            }
          }
        ]
      },
      {
        name: translate("MijnGegevens"),
        Sections: [
          {
            name: "stap_contactgegevens__contactgegevens",
            fields: {
              voorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              achternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true,
                autoComplete: true
              },
              geboortedatum: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.geboortedatum
              },
              bsn: {
                isRequired: false,
                predefinedFieldType: PredefinedFieldType.bsn
              },
              email: {
                predefinedFieldType: PredefinedFieldType.email,
                isRequired: true,
                autoComplete: true
              },
              telefoonnummer: {
                predefinedFieldType: PredefinedFieldType.telefoonnummer,
                autoComplete: true
              },
              hoeCommunicatie: {
                type: "radio",
                options: [
                  {
                    label: translate("Post"),
                    value: "post"
                  },
                  {
                    label: translate("Email"),
                    value: "email"
                  }
                ],
                ui: {
                  flexDirection: "column"
                },
                validate: {
                  isRequired: {
                    value: true
                  }
                }
              }
            }
          },
          {
            name: "stap_contactgegevens__adresgegevens",
            fields: GetAdresFieldSet(),
            dependsOn: dependsOnHoeCommunicatie
          }
        ]
      }
    ]
  };
};
